export default __webpack_public_path__ + "static/media/Raider's Straps of the Grasping Wild.2cd354e1.jpg";